module.exports = __webpack_public_path__ + "img/welcome_back.3f1c7b14.svg";